import { flow } from 'mobx';
import { ProductsStore } from './ProductsStore';
import { alertStore } from '@modules/core/store/AlertStore';
import { apiStore } from '@modules/core/store/ApiStore';
import { HttpClient } from '@modules/core/utils';

export class ProductsStoreAll extends ProductsStore {
    constructor() {
        super();
        this.loadProducts = this.loadProducts.bind(this);
    }

    loadProducts = flow(function* (this: ProductsStoreAll) {
        const { api, errorMessageHandler } = apiStore.api.getMyProducts;
        try {
            this.loadingStatusState.load();
            const availableProducts = yield HttpClient.TCMS.GET(api());
            this.products = availableProducts;
            this.loadingStatusState.loadSuccess();
        } catch (error) {
            this.loadingStatusState.loadError();
            alertStore.error(error, errorMessageHandler);
        }
    });
}
